import { uiColors } from '~/common/styles/colors'
import { InputProps } from '~/components/ui/atoms/input/types'

export function getTextFieldColorPrimitives({
  error,
}: Pick<InputProps, 'variant' | 'error' | 'disabled'>) {
  if (error) {
    return {
      helperText: {
        color: uiColors.content.danger,
      },
    }
  }

  return {
    label: {
      color: uiColors.content.secondary,
    },
    helperText: {
      color: uiColors.content.secondary,
    },
  }
}
